import React from 'react';
import { Employee, AttendanceStatus } from '../app/types';

interface EmployeeCardProps {
  employee: Employee;
  onSelect: (employee: Employee) => void;
  email: string;
}

const CheckIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg>;
const ClockIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" /></svg>;


const StatusIndicator: React.FC<{ status: number }> = ({ status }) => {
  const isPresent = status;
  
  return (
    <div className={`absolute top-4 right-4 flex items-center justify-center h-7 w-7 rounded-full shadow-md ${isPresent ? 'bg-primary dark:bg-dark-primary text-on-primary dark:text-dark-on-primary' : 'bg-surface-container-high dark:bg-dark-surface-container-high text-on-surface-variant dark:text-dark-on-surface-variant'}`}>
      {isPresent == 1 ? <CheckIcon /> : <ClockIcon />}
    </div>
  );
};


const EmployeeCard: React.FC<EmployeeCardProps> = ({ employee, onSelect, email }) => {
    
    const cardClasses = `
        relative rounded-2xl overflow-hidden
        transition-all duration-300 ease-in-out
        bg-surface-container-low dark:bg-dark-surface-container-low cursor-pointer hover:bg-surface-container-high dark:hover:bg-dark-surface-container-high hover:shadow-md        
    `;

  return (
    <div
      onClick={() => onSelect(employee)}
      className={cardClasses}
    >
      <StatusIndicator status={employee.Status} />
      <div className="p-5 flex flex-col items-center text-center">
        <img          
          src={`https://makosclock.com/ftpmakos/${employee.IdAttendance}.jpg?nocache=${Date.now()}`} 
          onError={(e) => {
            e.currentTarget.src = "../../images/user.png";
          }}          
          alt={employee.Name}
          className={`w-28 h-28 rounded-full object-cover mb-4 border-4 ${employee.Status == 1 ? 'border-primary/50 dark:border-dark-primary/50' : 'border-outline-variant dark:border-dark-outline-variant'}`}
        />
        <h3 className="text-lg font-bold text-on-surface dark:text-dark-on-surface">{employee.Name}</h3>
        <p className="text-sm text-on-surface-variant dark:text-dark-on-surface-variant">{employee.AreaName}</p>
        {/* {isPresent && employee.checkInTime && (
            <p className="text-sm text-primary dark:text-dark-primary mt-2 font-medium">
                Entrada: {formatCheckInTime(employee.checkInTime)}
            </p>
        )} */}
      </div>
    </div>
  );
};

export default EmployeeCard;
